module.exports = __webpack_public_path__ + "static/media/21ECLAC13.19eda50b.jpg";